import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const permissionApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/permissions' }),
  reducerPath: 'permissionApi',
  endpoints: (builder) => ({
    getAvailableActions: builder.query({
      query: () => '/available_actions'
    }),

    updatePermissions: builder.mutation({
      query: (data) => ({
        url: '',
        method: 'PATCH',
        body: data
      }),
      invalidatesTags: ['Permission']

    })
  })
})

export const { useGetAvailableActionsQuery, useUpdatePermissionsMutation } = permissionApi
